"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    studentAttemptQuestionModal: {
        result: 'Result ',
        studentName: 'Student Name ',
        emptyData: {
            primaryText: 'No data available',
            questionUnattempted: 'No student has attempted this question',
        },
        question: 'Q{{count}}',
        questionContent: 'Question {{count}} content',
        ariaLabel: {
            clickToSort: '{{name}}',
            sorting: 'Sorted {{name}}in {{order}} order',
            heading: 'Student assessment analysis for {{assessmentName}}',
            tableCaption: 'Table column headers with buttons are sortable',
            tableWarning: 'The result shown is of the latest attempt',
        },
    },
};
